import api from "@/services/api"
import type { Tenant } from "../sharedTypes/tenants"

export const retrieveSettings = async () => {
  const response = await api.get<Tenant>("/settings/", {
    version: 3,
  })
  return response.body
}
